import api from '@/api'
import { defineStore } from 'pinia'

type Iuser = {
  nickname?: string,
  name?: string,
  email?: string,
  last_name?: string,
  id?: number,
}

export const userStore = defineStore('user', {
  state: () => ({
    user: {} as Iuser,
    isLoggedIn: false as boolean,
    isActiveUser: false as boolean
  }),
  actions: {
    async setUser(payload: object) {
      this.user = payload
      await this.setIsLoggedIn(true)
    },
    async setIsLoggedIn(payload: boolean) {
      this.isLoggedIn = payload
    },
    async setIsActiveUser(payload: boolean) {
      this.isActiveUser = payload
    },
    async getActiveUser() {
      api.get('auth/isActiveUser').then(({ data }) => {
        this.setIsActiveUser(data.active)
      }).catch(({response}) => {
        if(response.status ==500){
          this.userLogout()
        }
        this.setIsActiveUser(false)
      })
    },
    async userLogout() {
      await this.setUser({})
      await this.setIsLoggedIn(false)
      await this.setIsActiveUser(false)
      localStorage.removeItem('user');
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'user',
        storage: localStorage,
      },
    ],
  }
})
